module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Index2"
  }, [_c('div', {
    staticClass: "l-container"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "category"
  }, [_c('div', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple"
    }],
    on: {
      "click": _vm.regist
    }
  }, [_vm._v("登録"), _c('i', {
    staticClass: "fa fa-fw fa-angle-down"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple"
    }],
    on: {
      "click": _vm.list
    }
  }, [_vm._v("リスト"), _c('i', {
    staticClass: "fa fa-fw fa-angle-down"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple"
    }],
    on: {
      "click": _vm.support
    }
  }, [_vm._v("対応履歴"), _c('i', {
    staticClass: "fa fa-fw fa-angle-down"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple"
    }],
    on: {
      "click": _vm.pdf
    }
  }, [_vm._v("PDF"), _c('i', {
    staticClass: "fa fa-fw fa-angle-down"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple"
    }],
    on: {
      "click": _vm.keiri
    }
  }, [_vm._v("経理"), _c('i', {
    staticClass: "fa fa-fw fa-angle-down"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [(_vm.user.type === 'admin' || _vm.user.type === 'owner' || _vm.user.type === 'mgr') ? [_vm._m(0)] : _vm._e(), _vm._v(" "), (_vm.user.type === 'admin' || _vm.user.type === 'owner' || _vm.user.type === 'mgr' || _vm.user.type === 'staff' || _vm.user.type === 'act') ? [_c('router-link', {
    attrs: {
      "id": "regist",
      "to": "/appointments/add"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-plus",
    attrs: {
      "title": "AP登録"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("AP登録")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("アポ登録画面です。家庭情報とは別です。契約にならなければ家庭登録はしません。")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "id": "regist",
      "to": "/families/add"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-plus",
    attrs: {
      "title": "家庭登録"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("家庭登録")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("AP情報と紐付けて家庭情報を登録します。個別のAP詳細画面からでも登録できます。")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "id": "regist",
      "to": "/students/add"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-plus",
    attrs: {
      "title": "生徒登録"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("生徒登録")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("家庭情報と紐付けて生徒情報を登録します。個別の家庭詳細画面からでも登録できます。")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "id": "regist",
      "to": "/tutors/add"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-plus",
    attrs: {
      "title": "先生登録"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("先生登録")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("先生の登録画面です。")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "id": "regist",
      "to": "/agreements/add"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-plus",
    attrs: {
      "title": "契約情報登録"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("契約情報登録")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("契約情報の登録画面です。契約情報は家庭ではなく生徒ごとに登録します。")])])] : _vm._e(), _vm._v(" "), (_vm.user.type === 'admin' || _vm.user.type === 'owner' || _vm.user.type === 'mgr') ? [_c('router-link', {
    attrs: {
      "id": "list",
      "to": "/users"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-list-ul",
    attrs: {
      "title": "ユーザーリスト"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("ユーザーリスト")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("NEOの登録ユーザー一覧です。MGR以上の権限で閲覧可能")])])] : _vm._e(), _vm._v(" "), (_vm.user.type === 'admin' || _vm.user.type === 'owner' || _vm.user.type === 'mgr') ? [_c('router-link', {
    attrs: {
      "id": "list",
      "to": "/advisors"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-list-ul",
    attrs: {
      "title": "アドバイザー"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("アドバイザー")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("アドバイザーの一覧です。")])])] : _vm._e(), _vm._v(" "), (_vm.user.type === 'admin' || _vm.user.type === 'owner' || _vm.user.type === 'mgr' || _vm.user.type === 'staff' || _vm.user.type === 'act') ? [_c('router-link', {
    attrs: {
      "id": "list",
      "to": "/appointments"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-list-ul",
    attrs: {
      "title": "APリスト"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("APリスト")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("アポの一覧です。契約前の家庭はここで管理します。")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "id": "list",
      "to": "/appointments/confirms"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-list-ul",
    attrs: {
      "title": "確認リスト"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("確認リスト")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("前日確認用リストです。")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "id": "list",
      "to": "/families"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-list-ul",
    attrs: {
      "title": "家庭リスト"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("家庭リスト")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("家庭の一覧です。契約前の家庭はここにはありません。")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "id": "list",
      "to": "/students"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-list-ul",
    attrs: {
      "title": "生徒リスト"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("生徒リスト")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("生徒の一覧です。対応履歴は家庭と生徒で共有されます。")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "id": "list",
      "to": "/tutors"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-list-ul",
    attrs: {
      "title": "先生リスト"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("先生リスト")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("先生の一覧です。探しをする為のレイアウトになっています。")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "id": "list",
      "to": "/agreements"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-list-ul",
    attrs: {
      "title": "契約リスト"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("契約リスト")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("契約の一覧です。生徒の詳細からも閲覧、編集できます。")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "id": "list",
      "to": "/students/inheritance"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-list-ul",
    attrs: {
      "title": "引継リスト"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("引継リスト")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("引継リストです。")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "id": "list",
      "to": "/tutor_channels"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-list-ul",
    attrs: {
      "title": "tutor_channels"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("家庭教師登録媒体リスト")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("家庭教師が登録された媒体の一覧です。重複も含めて一覧にしています。")])])] : _vm._e(), _vm._v(" "), (_vm.user.type === 'admin' || _vm.user.type === 'owner' || _vm.user.type === 'mgr' || _vm.user.type === 'staff' || _vm.user.type === 'act') ? [_c('router-link', {
    attrs: {
      "id": "support",
      "to": "/appointmentsupports"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-phone",
    attrs: {
      "title": "AP対応履歴"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("AP対応履歴")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("AP対応履歴の一覧です。")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "id": "support",
      "to": "/familysupports"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-phone",
    attrs: {
      "title": "家庭対応履歴"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("家庭対応履歴")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("家庭対応履歴の一覧です。")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "id": "support",
      "to": "/tutorsupports"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-phone",
    attrs: {
      "title": "先生対応履歴"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("先生対応履歴")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("先生対応履歴の一覧です。")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/tags"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-tags",
    attrs: {
      "title": "タグリスト"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("タグリスト")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("対応履歴に紐づけるタグの管理画面です。タグを削除すると対応履歴のタグも削除されます。")])])] : _vm._e(), _vm._v(" "), (_vm.user.type === 'admin' || _vm.user.type === 'owner' || _vm.user.type === 'mgr' || _vm.user.type === 'staff' || _vm.user.type === 'act') ? [_c('router-link', {
    attrs: {
      "id": "pdf",
      "to": "/familyfiles"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-file-pdf-o",
    attrs: {
      "title": "家庭ファイル"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("家庭ファイル")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("契約書、口座振替依頼書、などの家庭に関するPDFの一覧です。")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "id": "pdf",
      "to": "/studentfiles"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-file-pdf-o",
    attrs: {
      "title": "生徒ファイル"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("生徒ファイル")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("生徒に関するPDFの一覧です。報告書ページができるまでここで報告書を管理します。")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "id": "pdf",
      "to": "/tutorfiles"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-file-pdf-o",
    attrs: {
      "title": "先生ファイル"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("先生ファイル")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("履歴書、研修資料、などの先生に関するPDFの一覧です。")])]), _vm._v(" "), _vm._m(1)] : _vm._e(), _vm._v(" "), (_vm.user.type === 'admin') ? [_c('router-link', {
    attrs: {
      "id": "pdf",
      "to": "/reports"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-exclamation-triangle",
    attrs: {
      "title": "報告書"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("報告書")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("メンテナンス中")])])] : _vm._e(), _vm._v(" "), (_vm.user.type === 'admin' || _vm.user.type === 'owner' || _vm.user.type === 'mgr' || _vm.user.type === 'staff' || _vm.user.type === 'act') ? [_vm._m(2)] : _vm._e(), _vm._v(" "), (_vm.user.office === '仙台') ? [_vm._m(3)] : _vm._e(), _vm._v(" "), (_vm.user.type === 'admin' || _vm.user.type === 'owner' || _vm.user.type === 'mgr' || _vm.user.type === 'staff' || _vm.user.type === 'act') ? [_c('router-link', {
    attrs: {
      "to": "/student_tutors"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-file-text",
    attrs: {
      "title": "探しデータ"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("探しデータ")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("探しの管理画面です。")])])] : _vm._e(), _vm._v(" "), (_vm.user.type === 'admin') ? [_c('router-link', {
    attrs: {
      "to": "/events"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-file-text",
    attrs: {
      "title": "イベントリスト"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("イベントリスト")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("Todoに紐づけるイベントの管理画面です。")])])] : _vm._e(), _vm._v(" "), (_vm.user.type === 'admin') ? [_c('router-link', {
    attrs: {
      "to": "/todos"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-check-square",
    attrs: {
      "title": "Todoリスト"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Todoリスト")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("個人Todo、探しTodo、すべてのTodoが表示されます。")])])] : _vm._e(), _vm._v(" "), (_vm.user.type === 'admin' || _vm.user.type === 'owner' || _vm.user.type === 'act' || _vm.user.type === 'accounting') ? [_vm._m(4)] : _vm._e(), _vm._v(" "), (_vm.user.type === 'admin' || _vm.user.type === 'owner' || _vm.user.type === 'act' || _vm.user.type === 'mgr') ? [_c('router-link', {
    attrs: {
      "to": "/aggregates/appointments"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-line-chart",
    attrs: {
      "title": "集計-AP"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("集計-AP")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("アポの集計画面です。ADMIN / OWNER / ACT / MGR")])])] : _vm._e(), _vm._v(" "), (_vm.user.type === 'admin' || _vm.user.type === 'owner') ? [_c('router-link', {
    attrs: {
      "to": "/aggregates/contracts"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-line-chart",
    attrs: {
      "title": "集計-売上"
    }
  }), _vm._v(" "), _c('span', [_vm._v("集計-売上")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("売上の集計画面です。"), _c('br'), _vm._v("ADMIN / OWNER")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/aggregates/paymentdetails"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-line-chart",
    attrs: {
      "title": "集計-自社割賦"
    }
  }), _vm._v(" "), _c('span', [_vm._v("集計-自社割賦")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("自社割賦の集計画面です。"), _c('br'), _vm._v("ADMIN / OWNER")])])] : _vm._e(), _vm._v(" "), (_vm.user.type === 'admin' || _vm.user.type === 'owner' || _vm.user.type === 'mgr' || _vm.user.type === 'staff' || _vm.user.type === 'act') ? [_c('router-link', {
    attrs: {
      "to": "/aggregates/tutor_channels"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-line-chart",
    attrs: {
      "title": "集計-家庭教師"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("集計-家庭教師")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("家庭教師の集計画面です。")])])] : _vm._e(), _vm._v(" "), (_vm.user.type === 'admin' || _vm.user.type === 'owner' || _vm.user.type === 'act' || _vm.user.type === 'accounting') ? [_c('router-link', {
    attrs: {
      "to": "/contracts"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-exclamation-triangle",
    attrs: {
      "title": "appointment_channels"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("契約情報")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("ADMIN / OWNER / ACT")])])] : _vm._e(), _vm._v(" "), (_vm.user.type === 'admin' || _vm.user.type === 'owner' || _vm.user.type === 'act' || _vm.user.type === 'accounting') ? [_c('router-link', {
    attrs: {
      "to": "/paymentdetails"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-exclamation-triangle",
    attrs: {
      "title": "appointment_channels"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("テキスト支払")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("ADMIN / OWNER / ACT")])])] : _vm._e(), _vm._v(" "), (_vm.user.type === 'admin' || _vm.user.type === 'owner' || _vm.user.type === 'act' || _vm.user.type === 'accounting') ? [_c('router-link', {
    attrs: {
      "to": "/paymentdetails2s"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-exclamation-triangle",
    attrs: {
      "title": "appointment_channels"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("管理費支払")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("ADMIN / OWNER / ACT")])])] : _vm._e(), _vm._v(" "), (_vm.user.type === 'admin') ? [_c('router-link', {
    attrs: {
      "to": "/channels"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-graduation-cap",
    attrs: {
      "title": "channels"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("家庭教師登録媒体")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("ADMIN媒体を管理する画面です。")])])] : _vm._e(), _vm._v(" "), (_vm.user.type === 'admin') ? [_c('router-link', {
    attrs: {
      "to": "/appointment_channels"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-exclamation-triangle",
    attrs: {
      "title": "appointment_channels"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("appointment_channels")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("メンテナンス中")])])] : _vm._e()], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "regist",
      "href": "http://153.126.169.95/users/sign_up"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-plus",
    attrs: {
      "title": "User登録"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("ユーザー登録")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("ユーザー登録を行います。MGR以上の権限で登録可能")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "pdf",
      "href": "http://153.126.169.95/student_tutors/search?limit=30",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-file-pdf-o",
    attrs: {
      "title": "報告書管理"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("報告書管理")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("別タブで開きます")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "http://153.126.169.95/student_tutors/?limit=30",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-file-pdf-o",
    attrs: {
      "title": "指導情報"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("指導情報")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("生徒先生の紐付けです")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/kenshus"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-leanpub",
    attrs: {
      "title": "スケジュール"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("スケジュール")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("面接、研修の予定を管理します。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "keiri",
      "href": "/contracts"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-money",
    attrs: {
      "title": "経理"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("経理")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("経理管理画面です。ADMIN / OWNER / ACT")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fbbae7fe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/Index/Index2.vue
// module id = 1491
// module chunks = 0